import { HeaderDashboardProvider } from "./context/HeaderDashboard.context"
import Header from "./components/header/Header"

function HeaderDashboard() {
  return (
    <HeaderDashboardProvider>
      <Header/>
    </HeaderDashboardProvider>
  )
}

export default HeaderDashboard